package com.milta.core.localization.translations.en

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Import — Photo",
    titlePdf = "Import — PDF",
    titleSpreadsheet = "Import — Excel / CSV",
    fileSentSuffix = "just sent",
    fileWaitingConnectionLabel = "waiting for connection",
    analysingTitle = "Reading the document…",
    analysingSubtitle = "Extracting the deliveries can take a few seconds.",
    analysingSubtitlePdf = "Claude Haiku extracts the deliveries — this can take a few seconds on a scanned PDF.",
    stepFileSent = "File sent",
    stepExtracting = "Extracting fields",
    stepReview = "Review before adding",
    successTitle = "Delivery detected",
    successSubtitle = "Check the information before adding it to the route.",
    addToRouteButton = "Add to the route",
    scanAnotherButton = "Scan another document",
    partialTitle = "Almost complete",
    partialSubtitle = "One field could not be read on the document.",
    missingFieldPlaceholder = "To complete…",
    partialBannerText = "Some information could not be read. You can validate as is and complete it later, or send a clearer document.",
    retryFileButton = "Send another file",
    validateAndContinueButton = "Validate and continue",
    errorTitleUnreadable = "Unreadable document",
    errorTitleMissingFields = "Information not found",
    errorTitleNetworkError = "Problem during analysis",
    errorTitleGeneric = "Analysis failed",
    errorSubtitle = "We could not detect a delivery on this file.",
    errorBannerSuffixUnreadable = "image too dark or text cut off. Take a well-framed, well-lit photo, or send a clearer file.",
    errorBannerSuffixMissingFields = "no usable information was found. Check the file's content or send another one.",
    errorBannerSuffixNetworkError = "the analysis service hit a network issue. Try again in a few moments.",
    errorBannerSuffixGeneric = "an unexpected error occurred during analysis. Try again or send another file.",
    retryWithNewFileButton = "Retry with another file",
    manualEntryButton = "Enter manually",
    newDocumentButton = "Import a new document",
    serviceUnavailableTitle = "Service temporarily unavailable",
    serviceUnavailableSubtitle = "The automatic analysis isn't responding right now.",
    serviceUnavailableBanner = "Try again in a few moments, or complete the delivery manually in the meantime.",
    offlineTitle = "You are offline",
    offlineSubtitle = "Your file is ready but hasn't been sent yet.",
    offlineBanner = "Reconnect to the internet then restart the analysis. Nothing was sent to the server — nothing was deducted from your AI credit.",
    retryOfflineButton = "Retry — no connection",
    unsupportedFormatBanner = "Unsupported file format. Choose a photo, a PDF, or an Excel/CSV file.",
    validationTitle = "Review the deliveries",
    fileRejectedTitle = "File not sent",
    fileRejectedSubtitle = "Choose another file to continue.",
    bannerFileRequired = "no file was selected. Choose a PDF file to continue.",
    bannerInvalidPdfFormat = "unsupported format. Only PDF files are accepted here.",
    bannerFileTooLarge = "file too large. Choose a lighter PDF file.",
    chooseAnotherFileButton = "Choose another file",
    processingCanLeaveNote = "Your file has been sent. You can leave this screen, the analysis continues. You will find your import in “Import deliveries”.",
    uploadingPhotoStep = "Sending the photo",
    uploadingFileStep = "Sending the file",
    photoSentStep = "Photo sent",
    uploadProgress = "%1 of %2",
    uploadingPhotoBanner = "Sending. Keep this screen open until the upload is complete: the analysis starts as soon as the photo is received.",
    uploadingFileBanner = "Sending. Keep this screen open until the upload is complete: the analysis starts as soon as the file is received.",
    cancelUploadButton = "Cancel upload",
    cancelImportButton = "Cancel import",
    cancelImportDialogTitle = "Cancel this import?",
    cancelImportAnalysingScanMessage = "The analysis stops right away and no delivery will be added to your route. The analysis already started is still deducted from your AI credit.",
    cancelImportAnalysingFileMessage = "The analysis stops right away and no delivery will be added to your route. The analysis already started is still deducted from your AI credit.",
    cancelImportConfirmButton = "Yes, cancel the import",
    continueAnalysisButton = "Continue the analysis",
    cancelImportReviewMessage = "The %s detected deliveries are removed and none is added to your route. You go back to choosing a source.",
    cancelImportReviewMessageSingle = "The detected delivery is removed and is not added to your route. You go back to choosing a source.",
    continueReviewButton = "Continue reviewing",
    importCancelledNotice = "Import cancelled. No delivery was added.",
    serviceUnavailableRetryBanner = "Your file is kept. Restart the analysis without sending it again, or complete the delivery manually in the meantime.",
    serviceUnavailableExhaustedBanner = "This document could not be analysed. Add the deliveries manually, or start again with a new document.",
    errorTitleTooLong = "Document too long",
    errorSubtitleTooLong = "This document contains too many deliveries to be analysed in one go.",
    errorBannerSuffixTooLong = "split it into several shorter files, or enter the deliveries manually.",
    errorTitleTooLarge = "Document too large",
    errorSubtitleTooLarge = "This document exceeds the size the analysis can handle.",
    errorBannerSuffixTooLarge = "reduce its size or split it into several files, or enter the deliveries manually.",
    errorTitleNoDeliveries = "No deliveries found",
    errorSubtitleNoDeliveries = "The document was read, but no deliveries were found in it.",
    errorBannerSuffixNoDeliveries = "check that it contains a list of deliveries, or enter them manually.",
    errorTitleSourceExpired = "File expired",
    errorSubtitleSourceExpired = "This file is no longer available for a new analysis.",
    errorBannerSuffixSourceExpired = "choose it again to restart the analysis.",
    errorTitleOriginRouteDeleted = "Import cancelled",
    errorSubtitleOriginRouteDeleted = "The original route was deleted: this import is cancelled.",
    errorBannerSuffixOriginRouteDeleted = "import cancelled, no delivery was added.",
    activeImportHeader = "Import in progress",
    activeImportAnalysingPill = "Analysis in progress",
    activeImportFailedPill = "The analysis failed",
    activeImportReadyPill = "Ready to validate",
    activeImportRunningNote = "One import at a time. Wait for the analysis to finish, or cancel it, to import another document.",
    activeImportFailedNote = "One import at a time. Restart or cancel this import to import another document.",
    activeImportReadyNote = "The imported deliveries are ready. Tap to validate them.",
    activeImportRunningOtherRouteNote = "An import is being analysed for the route of %s. Tap to open this route. Wait for the analysis to finish, or cancel it, to import another document.",
    activeImportReadyOtherRouteNote = "The deliveries for the route of %s are ready. Tap to open this route and validate them.",
    activeImportFailedOtherRouteNote = "The import for the route of %s failed. Restart or cancel this import to import another document.",
    activeImportRunningNewRouteNote = "An import is being analysed for a new route. Tap to resume creating it. Wait for the analysis to finish, or cancel it, to import another document.",
    activeImportReadyNewRouteNote = "The deliveries for the new route are ready. Tap to resume creating it and validate them.",
    activeImportFailedNewRouteNote = "The import for the new route failed. Restart or cancel this import to import another document.",
    activeImportRouteLink = "Route of %s",
    activeImportNewRouteLink = "New route (being created)",
    weekdayNamesInText = listOf("Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"),
)
